var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEditPencilIcon = function SvgEditPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit-pencil-icon_svg__clip0_40_25906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.666 14.333 3.7-1.423c.236-.091.354-.136.465-.196.098-.053.192-.114.28-.182.1-.077.19-.167.369-.346L14 4.666A1.886 1.886 0 0 0 11.332 2l-7.52 7.52c-.18.179-.269.268-.346.368-.068.088-.13.181-.182.28-.06.11-.105.229-.196.465l-1.423 3.7Zm0 0 1.372-3.568c.098-.255.147-.382.232-.44a.333.333 0 0 1 .252-.054c.1.019.198.115.391.309l1.506 1.506c.193.193.29.29.31.39a.333.333 0 0 1-.054.253c-.059.085-.186.134-.442.232l-3.567 1.372Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

export default SvgEditPencilIcon;